/**
 * Ethnicity helpers shared across the app.
 *
 * Storage format: `ethnicity` may be either a single string (legacy records)
 * or an array of strings (multi-select). These helpers normalize both.
 */

export const ETHNIC_BACKGROUNDS = [
  'Native American',
  'Alaska Native',
  'First Nations',
  'Métis',
  'Inuit',
  'Native Hawaiian',
  'Pacific Islander',
  'Latino / Hispanic',
  'Black / African American',
  'Asian',
  'Middle Eastern / North African',
  'White / Caucasian',
  'Mixed / Multiracial',
  'Other',
];

export const INDIGENOUS_GROUPS = new Set([
  'Native American',
  'Alaska Native',
  'First Nations',
  'Métis',
  'Inuit',
  'Native Hawaiian',
]);

/** Normalize any stored ethnicity value into a de-duped array of strings. */
export function toEthnicityArray(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  return [String(value)];
}

/** Human-friendly display string — joins multiple selections with " · ". */
export function formatEthnicity(value, sep = ' · ') {
  return toEthnicityArray(value).join(sep);
}

/** True if ANY selected ethnicity is Indigenous (array-safe). */
export function hasIndigenous(value) {
  return toEthnicityArray(value).some((e) => INDIGENOUS_GROUPS.has(e));
}
